import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { t } from 'i18next';

import { BaseComponent } from './BaseComponent';
import { SidebarModule } from '../constants/Enums';
import { SelectBoxStoreState, SelectBoxStore, SelectBoxOption } from '../stores/SelectBoxStore';
import { UIHelper } from '../utils/UIHelper';
import { SelectBoxActions } from '../actions/SelectBoxActions';
import { HoverTimeout } from '../constants/LayoutConstants';
import { LongButton } from './LongButton';

interface OverlaySelectBoxProps {
    sidebar: SidebarModule;
    sidebarOrientation: string;
}

export class OverlaySelectBox extends BaseComponent<OverlaySelectBoxProps, SelectBoxStoreState> {
    public componentDidUpdate(): void {
        if (ReactDOM.findDOMNode(this)) {
            const header: NodeListOf<Element> = (ReactDOM.findDOMNode(this) as Element).getElementsByClassName('select-box-header');
            if (header && header[0] != null && parseInt(jQuery(header[0]).css('min-height'), 10) < header[0].clientHeight) {
                jQuery(header[0]).addClass('small-font');
            }
            UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element, '.select-box');
        }
    }

    public componentWillMount(): void {
        this.addStoreListener(SelectBoxStore, this.onChange);
        this.onChange();
    }

    /**
     * info; underlay is needed to prevent scrolling of background on touchmove,
     * if we stop the event on the complete overlay scrolling in the selectbox is prevented too
     */
    public render(): JSX.Element | null {
        const title: string = this.state.title ? this.state.title : t('Please choose');
        if (this.state.options.length > 0 && this.state.asOverlay) {
            return (
                <div className={this.getCSSClass()} onClick={this.closeSelect}>
                    <div className="select-underlay" onTouchMove={UIHelper.stopEvent}/>
                    <div className={'select-box-container' + (this.props.sidebarOrientation === 'right' ? ' on-right-side' : '')}>
                        <div className={'select-box-header'} onClick={this.closeSelect} onTouchMove={UIHelper.stopEvent}>
                            <div style={{width: '100%'}}>{title}</div>
                        </div>
                        <div className="select-box scrollbar-wcf" onClick={UIHelper.stopEvent} style={{border: 0}}>
                            {this.state.options.map(this.getOption)}
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }

    protected getOption = (selectOption: SelectBoxOption, index: number): JSX.Element | null => {
        if (selectOption.name === 'separator') {
            return null;
        }
        return (
            <LongButton
                size="small"
                active={(this.state.value === selectOption.value)}
                key={index}
                shortBorder={true}
                onClick={this.onClick(selectOption.value, selectOption.callback)}
                icon={selectOption.icon}
                className={selectOption.className}
            >
                {selectOption.name}
            </LongButton>
        );
    };

    protected onChange = (): void => {
        this.setState(SelectBoxStore.getState());
    };

    protected closeSelect(event?: React.MouseEvent): void {
        SelectBoxActions.closeSelectBox();
        if (event != null) {
            UIHelper.stopEvent(event);
        }
    }

    protected onClick = (value: string | number | boolean, callback?: () => void) => (event?: React.MouseEvent) => {
        this.setState(jQuery.extend({}, SelectBoxStore.getState(), {value: value}));
        if (callback) {
            callback();
        }
        UIHelper.stopEvent(event);
        window.setTimeout(
            () => {this.closeSelect(); },
            HoverTimeout
        );
    };

    protected getCSSClass: () => string = () => {
        let result: string = 'select-overlay';
        if (this.props.sidebar === SidebarModule.PROJECTS) {
            result += ' full-height';
        }
        return result;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/OverlaySelectBox.tsx